import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class TripComponent {
    constructor() {
        TripComponent.anchors()
        TripComponent.bookingForm()
        TripComponent.bookingButton()
        TripComponent.moreMedias()
        TripComponent.crossSlide()
        TripComponent.accordeon()
    }

    static anchors() {
        if (window.matchMedia('(min-width: 1000px)').matches) {
            const anchorList = ['#excerpt', '#photos', '#description', '#legals']

            anchorList.forEach((anchor) => {
                const target = document.querySelector(anchor)
                const observer = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                $('.customer_trip__left__anchors a').removeClass('active')
                                $(
                                    `.customer_trip__left__anchors a[data-target="${anchor}"]`,
                                ).addClass('active')
                            }
                        })
                    },
                    {
                        root: null,
                        threshold: 0.1,
                    },
                )
                if (target) {
                    observer.observe(target)
                }
            })
        }
    }

    static bookingButton() {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            const target = document.querySelector('#booking-quotation-form')
            const observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            $('#booking-quotation-button').removeClass('fixed')
                        } else {
                            $('#booking-quotation-button').addClass('fixed')
                        }
                    })
                },
                {
                    root: null,
                    threshold: 0.1,
                },
            )
            observer.observe(target)
        }
    }

    static bookingForm() {
        const form = $('[data-trip-form="booking"]')

        form.submit((e) => {
            e.preventDefault()

            const target = form.data('action')
            const values = {}
            $.each($(e.target).serializeArray(), (i, field) => {
                values[field.name] = field.value
            })

            window.location.href = `${target}?trip_id=${values.idTrip}&adult=${values.adultNumber}&child=${values.childNumber}`
        })
    }

    static moreMedias() {
        const element = $('.customer_trip__left__images__gallery')
        if (element.length > 0 && !element.is(':hidden')) {
            $('.see-more').on('click', function () {
                $('.customer_trip__left__images__gallery a').removeClass('hidden')
                $(this).hide()
                return false
            })
        }
    }

    static async crossSlide() {
        const element = '.customer_trip__crosssell__posts'
        if (element.length > 0 && !$('body').hasClass('eco-mode-active')) {
            const swiperKey = 'trip-crosssell-swiper'
            const slideItem = `[data-swiper="${swiperKey}"] > .card-sejour__item`

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.25,
                spaceBetween: 10,
                speed: 2000,
                navigation: {
                    nextEl: `#swiper-${swiperKey}-next`,
                    prevEl: `#swiper-${swiperKey}-prev`,
                },
                keyboard: true,
                loop: false,
                freeMode: {
                    enabled: true,
                },
                freeModeFluid: true,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 2.25,
                        spaceBetween: 20,
                    },
                    1000: {
                        slidesPerView: 2.5,
                        spaceBetween: 40,
                    },
                    1220: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
            }

            $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')

            const mySwiper = await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
        }
    }

    static accordeon() {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            $('.customer_trip .label').on('click', function () {
                const target = $(this).next('.content-label')
                if ($(this).hasClass('open')) {
                    $(this).removeClass('open')
                    target.slideUp()
                } else {
                    $(this).addClass('open')
                    target.slideDown()
                }
            })
        }
    }
}
